import { useState } from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';

import PWAPrompt from './PWAPrompt';

import { Footer } from '../../App/Footer';
import { Avatar } from '../../Global/Atomics/Avatar';
import Box from '../../Global/Atomics/Box';
import { LinkButton } from '../../Global/Atomics/Button';
import { Container } from '../../Global/Atomics/Container';
import { Heading } from '../../Global/Atomics/Heading';
import { Map } from '../../Global/Widgets/Map/Map';
import { Paragraph } from '../../Global/Atomics/Paragraph';
import CustomIcon from '../../Global/Icons/CustomIcon';

import { useTranslationContext } from '../../../contexts/TranslationContext';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useGlobalStateContext } from '../../../contexts/GlobalStateContext';
import { capitalizeWords } from '../../../utils';

const Home = () => {
    const [section, setSection] = useState<string | null>(null);
    const [position, setPosition] = useState<{ lat: number, lng: number } | null>(null);
    const { setGlobalState } = useGlobalStateContext();
    const { resources } = useTranslationContext();
    const { user } = useAuthContext();

    return (
        <>
            <Box position="relative" bg="green-nova" height="45vh" pt="lg">
                <Container>
                    {/* WELCOME & INFO */}
                    <Row center="md">
                        <Col xs={12} md={9}>
                            {/* Hi, <User> */}
                            <Box mb="lg" display="flex">
                                <Heading level={1} typography="text-xl-light" customColor="white">{resources.label.hello},&nbsp;</Heading>
                                <Heading level={1} typography="text-xl-bold" customColor="white">{user?.name.split(" ")[0]} {user?.name.split(" ").pop()}</Heading>
                            </Box>

                            {/* PWA add home prompt */}
                            <PWAPrompt />

                            {/* Problems? */}
                            <Box mb="md">
                                <Paragraph typography="text-m-semibold" customColor="white" mb="xs">{resources.home.title}</Paragraph>
                                <Paragraph typography="text-xs-medium" customColor="white">{resources.home.paragraph}</Paragraph>
                            </Box>
                        </Col>
                    </Row>

                    {/* MAP */}
                    <Row center="xs">
                        <Col xs={12} md={9}>
                            <Box position="relative" height="500px" bg="blue-1" boxShadow="level2" borderRadius="lg" mb="lg" zIndex={100}>
                                <Map
                                    displaySections
                                    getLatLng={(val) => { setPosition(val); }}
                                    getSection={(val) => { setSection(val); }}
                                />
                            </Box>
                        </Col>
                    </Row>

                    {/* CTA */}
                    <Row center="xs">
                        <Col xs={12} md={6}>
                            <Box display="flex" justifyContent="space-around">
                                <Box display="flex" flexDirection='column' justifyContent="center" alignItems="center">
                                    <LinkButton to="/report" state={{ section, position }} aria-label={resources.label.newReport} disabled={!position || !section}>
                                        <Avatar border="none" bg={!position || !section ? "coolgray-2" : "error-4"} size={56}>
                                            <CustomIcon icon="PlusNova" customColor='white' />
                                        </Avatar>
                                    </LinkButton>
                                    <Paragraph typography='text-xs-regular'>{resources.label.newReport}</Paragraph>
                                </Box>
                                <Box display="flex" flexDirection='column' justifyContent="center" alignItems="center">
                                    <LinkButton to="/profile" aria-label={resources.label.viewPending} onClick={() => setGlobalState({ id: 'tab', value: 0 })}>
                                        <Avatar border="2.5px solid #000" bg="white" size={56}>
                                            <CustomIcon icon="DocNova" customColor='black-1' />
                                        </Avatar>
                                    </LinkButton>
                                    <Paragraph typography='text-xs-regular'>{capitalizeWords(resources.label.myIncidents)}</Paragraph>
                                </Box>
                            </Box>
                        </Col>
                    </Row>
                </Container>

                {/* MAIN FOOTER */}
                <Footer />
            </Box>
        </>
    );
};

export default Home;
